import * as React from 'react';
import * as styles from './slonoTopCard.css';
import { SlonoTopHeader } from './header/slonoTopHeader';
import { SlonoTopGallery } from './gallery/slonoTopGallery';
import { IOfferCardComponentsProps, IOfferCardContext, IOfferCardOwnProps } from '../offer-card';
import { offerHelper } from '../presenter';
import { IABExperiment } from '@cian/api-models/monolith-python/cian-api/site/v1/get-ab-experiments';
import { IJsonQuery } from '../types/json-query';
import { IOffer } from '../types/offer';
import { IUser } from '../types/user';
import * as PropTypes from 'prop-types';
import { IComplaintsHelpers } from '../types/complaints';
import { SlonoTopFooterContainer } from './footer/container';

import { mergeStyles } from '@cian/utils';
import { CallbackModalContainer } from '../common/components/callback_modal';
import {
  cardAddressBlockClick,
  cardClickBrandingGoToOffer, cardClickDescriptionMore,
  cardClickGalleryGoToOffer,
  cardClickGoToOffer,
  titleClick,
  toFromFavorite,
} from './tracking/tracking';
import { getAgentPhone } from '../utils/getAgentPhone';

export interface ISolonoTopCard extends IOfferCardOwnProps {
  api: IOfferCardComponentsProps;
  /** Перечень регионов ранжированного поиска */
  mlSearchRegions?: number[];
  /** ML-ранжирование, без проверки региона  */
  isMlSearchForAll?: boolean;
  baseUrl: string;
  currentSubdomain: string;
  experiments: IABExperiment[];
  isSimilar: boolean;
  jsonQuery: IJsonQuery;
  offer: IOffer;
  user: IUser | null;
  currentPath: string | undefined;
  suggestionDistancesSeoText: string | undefined;
  complaintsHelpers: IComplaintsHelpers;
  position: number;

  isHideOfferFetching?: boolean;
  isOnHideAnimation?: boolean;
  qsToUris?: { [key: string]: string; };
  defaultPhone?: string;
  defaultEmail?: string;
  isLightView?: boolean;
  /** Возможность получить ссылку на контейнер */
  containerRef?: React.RefObject<HTMLDivElement>;
}

interface ISlonoTopCardState {
  isCallbackModalOpened: boolean;
  isOfferHidden: boolean;
}

export class SlonoTopCard extends React.Component<ISolonoTopCard, ISlonoTopCardState> {

  // tslint:disable-next-line:no-any
  public static childContextTypes: { [key in keyof IOfferCardContext]: PropTypes.Requireable<any> } = {
    api: PropTypes.object,
    baseUrl: PropTypes.string,
    currentSubdomain: PropTypes.string,
    defaultEmail: PropTypes.string,
    defaultPhone: PropTypes.string,
    experiments: PropTypes.array,
    httpApi: PropTypes.object,
    isMlSearchForAll: PropTypes.bool,
    isSimilar: PropTypes.bool,
    jsonQuery: PropTypes.object,
    logger: PropTypes.object,
    mlSearchRegions: PropTypes.array,
    offer: PropTypes.object,
    offerHelper: PropTypes.object,
    user: PropTypes.object,
    maxAuctionBet: PropTypes.number,
    auctionMinBet: PropTypes.number,
    auctionMaxBet: PropTypes.number,
    validateStep: PropTypes.bool,
    newbuildingLabel: PropTypes.object,
    onlineShowEnabled: PropTypes.bool,
  };

  public state = {
    isCallbackModalOpened: false,
    isOfferHidden: false,
  };

  public getChildContext(): IOfferCardContext {
    const {
      config, api, baseUrl, currentSubdomain, defaultEmail = '', defaultPhone = '', experiments, httpApi,
      isSimilar, jsonQuery, logger, offer, user,
    } = this.props;

    api.tracking = {
      ...api.tracking,
      trackAddressClick: cardAddressBlockClick,
    };

    return {
      api,
      baseUrl,
      currentSubdomain,
      defaultEmail,
      defaultPhone,
      experiments,
      httpApi,
      isMlSearchForAll: config.get<boolean>('isMlSearchForAll.Enabled') || false,
      isSimilar,
      jsonQuery,
      logger,
      mlSearchRegions: config.get<number[]>('mlSearchRegions') || [],
      offer,
      offerHelper: offerHelper(offer),
      user,
      validateStep: config.get<boolean>('validateStep') || false,
      newbuildingLabel: null,
      onlineShowEnabled: false,
    };
  }

  public render() {
    const {
      currentPath,
      qsToUris,
      suggestionDistancesSeoText,
      complaintsHelpers,
      position,
      offer,
      isSimilar,
      api,
      currentSubdomain,
      isOnHideAnimation,
      isHideOfferFetching,
      httpApi,
      containerRef,
    } = this.props;

    const { isCallbackModalOpened } = this.state;

    const helper = offerHelper(offer);
    const isPhoneHidden = !!offer.kp && !offer.kp.displayBuilderPhone;
    const agentAvatarUrl = helper.presenters.getAgentAvatarUrl();
    const isPro = helper.isPro();
    const agentName = helper.presenters.getAgentName();
    const userId = helper.presenters.getCianUserId();
    const companyName = helper.presenters.getCompanyName();
    const agentPhone = getAgentPhone(offer);
    const callbackSettings = offer.workTimeInfo || {};
    const isNewbuildingTourAvailable = offer.isNewbuildingTourAvailable;

    return (
      <div
        { ...mergeStyles([
          styles['slono-top'],
          this.state.isOfferHidden && styles['offer-hidden'],
          isOnHideAnimation && styles['hide-offer-animation'],
          this.props.isLightView ? styles['light'] : null,
        ]) }
        onClick={ this.handleOfferCardClick }
        ref={containerRef}
      >

        <SlonoTopHeader
          agentAvatarUrl={ agentAvatarUrl }
          isPro={ isPro }
          name={ companyName || agentName || `ID ${userId}` }
          onClick={ this.onHeaderClick }
          isFromBuilder={ helper.isFromBuilder() }
          isFromSeller={ helper.isFromSeller() }
          userTrustLevel={ helper.presenters.getUserTrustLevel() }
          isByHomeOwner={ helper.isByHomeowner() }
          isHomeownerVerified={ helper.isHomeownerVerified() }
          verifyWay={ helper.getVerifyWay() }
        />

        <SlonoTopGallery
          hasVideo={ !!(offer.videos && offer.videos.length) }
          photos={ offer.photos }
          className={ styles['gallery_margin'] }
          onClick={ this.onGalleryClick }
          promoInfo={ offer.promoInfo }
          isNew={ offer.isNew }
          fullUrl={ offer.fullUrl }
          isNewbuildingTourAvailable={isNewbuildingTourAvailable}
        />

        <SlonoTopFooterContainer
          currentPath={ currentPath }
          qsToUris={ qsToUris }
          suggestionDistancesSeoText={ suggestionDistancesSeoText }
          handleTitleClick={ this.handleTitleClick }
          complaintsHelpers={ complaintsHelpers }
          position={ position }
          agentPhone={ agentPhone }
          isPhoneHidden={ isPhoneHidden }
          isSimilar={ isSimilar }
          toggleCallbackModal={ this.toggleCallbackModal }
          handleHideFromPrintClick={ this.handleHideFromPrintClick }
          offer={ offer }
          api={ api }
          currentSubdomain={ currentSubdomain }
          //tslint:disable-next-line:no-any
          onDescriptionClick={ this.onDescriptionClick as any }
          isOnHideAnimation={ isOnHideAnimation }
          isHideOfferFetching={ isHideOfferFetching }
          onFavoriteChange={ this.onFavoriteChange }
        />

        {
          isCallbackModalOpened && !!agentPhone && (
            <CallbackModalContainer
              useOldWidget={ offer.category !== 'newBuildingFlatSale' }
              gaLabel={ offer.gaLabel || '' }
              agentPhone={ agentPhone }
              { ...callbackSettings }
              close={ this.toggleCallbackModal }
              httpApi={ httpApi }
            />
          )
        }
      </div>
    );
  }

  private onFavoriteChange = (isFavorite: boolean) => {
    if (isFavorite) {
      toFromFavorite(this.props.offer, 'add');
    } else {
      toFromFavorite(this.props.offer, 'remove');
    }
  }

  private onHeaderClick = (evt: React.MouseEvent) => {
    evt.stopPropagation();
    const { offer } = this.props;
    cardClickBrandingGoToOffer(offer);
    this.navigateToOffer();
  }

  private navigateToOffer = () => {
    const { offer } = this.props;
    window.open(`${offer.fullUrl}#slono-top`, '_blank');
  }

  private onGalleryClick = (evt: React.MouseEvent) => {
    evt.stopPropagation();
    const { offer } = this.props;
    cardClickGalleryGoToOffer(offer);
    this.navigateToOffer();
  }

  private handleTitleClick = (e: React.MouseEvent<HTMLAnchorElement>) => {
    e.stopPropagation();
    titleClick(this.props.offer);
    this.navigateToOffer();
  }

  private toggleCallbackModal = () => {
    this.setState({
      isCallbackModalOpened: !this.state.isCallbackModalOpened,
    });
  }

  private handleHideFromPrintClick = () => {
    this.setState({
      isOfferHidden: true,
    });
  }

  private onDescriptionClick = (evt: React.MouseEvent) => {
    evt.stopPropagation();
    cardClickDescriptionMore(this.props.offer);
    this.navigateToOffer();
  }

  private handleOfferCardClick = () => {
    const { offer, api } = this.props;
    const { isPopupsOpened } = api.offerCard;

    if (isPopupsOpened()) {
      return;
    }

    cardClickGoToOffer(offer);
    this.navigateToOffer();
  }
}
